<template>
  <MyHeader />
  <article>
    <slot />
  </article>
  <MyFooter />
  <LoginPopup v-if="isShowLoginPopup" @on-login-success="() => location.reload()" />
  <ProfilePopupLayer v-if="isShowProfilePopup" />
</template>

<script lang="ts" setup>
const { $t } = useNuxtApp()
const { locale } = useI18n()
const { isWebview } = useWebviewBridge()
const buildTime = useBuildTime()
const { shareImage } = useShare()

const description = computed(() => {
  return removeTag($t('이해와배려가담긴따뜻한말br어머니사랑의언어로소통해보세요br어머니사랑이닿는곳에평화가깃듭니다'))
})
useHead({
  script: [
    {
      src: 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js',
      integrity: 'sha384-TiCUE00h649CAMonG018J2ujOgDKW/kVWlChEuu4jK2vxfAAD0eZxzCKakxg55G4',
    },
    {
      src: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
    },
  ],
})
useHead({
  meta: [
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0, user-scalable=no',
    },
    { charset: 'utf-8' },
    { 'http-equiv': 'X-UA-Compatible', 'content': 'IE=Edge' },
    { name: 'format-detection', content: 'telephone=no' },
    {
      name: 'description',
      content: description,
    },
    { property: 'og:url', content: 'https://heavenlymotherslove.org' },
    {
      property: 'og:title',
      content: description,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:image',
      content: shareImage,
    },
    { name: 'twitter:card', content: 'summary_large_image' },
    {
      name: 'twitter:title',
      content: description,
    },
    {
      name: 'twitter:description',
      content: description,
    },
    { name: 'twitter:image', content: shareImage },
  ],
  link: [
    // icon
    { rel: 'shortcut icon', type: 'image/x-icon', href: '/favicon.ico' },
    { rel: 'icon', sizes: '120x120', href: '/favicon/favicon-round-120.png' },
    { rel: 'icon', sizes: '152x152', href: '/favicon/favicon-round-152.png' },
    { rel: 'icon', sizes: '512x512', href: '/favicon/favicon-round-512.png' },
    {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: '/favicon/favicon-152.png',
    },
    {
      rel: 'apple-touch-icon-precomposed',
      sizes: '270x270',
      href: '/favicon/favicon-270.png',
    },
    {
      rel: 'apple-touch-icon-precomposed',
      sizes: '152x152',
      href: '/favicon/favicon-152.png',
    },
    {
      rel: 'apple-touch-icon-precomposed',
      sizes: '120x120',
      href: '/favicon/favicon-120.png',
    },
    {
      rel: 'apple-touch-icon-precomposed',
      sizes: '32x32',
      href: '/favicon/favicon-32.png',
    },
    // CSS
    // { rel: "stylesheet", href: "http://wds.watv.org/css/logo.css" },
    { rel: 'stylesheet', href: `/css/reset.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: `/css/fontello_v210727.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: `/css/style.css?${useBuildTime()}` },
    // { rel: 'stylesheet', href: `/css/style_add.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: `/css/dev.css?${useBuildTime()}` },
    { rel: 'stylesheet', href: () => `/css/lang/${locale.value}.css?${buildTime}` },
    {
      rel: 'stylesheet',
      href: computed(() => {
        if (isWebview.value) {
          return `/css/webview.css?${buildTime}`
        }
        return ''
      }),
    },

    // 언어별 CSS 링크
    { rel: 'preconnect', href: () => `https://fonts.googleapis.com` },
    { rel: 'preconnect', href: () => `https://fonts.gstatic.com` },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap',
    },
    {
      rel: 'stylesheet',
      href: computed(() => {
        if (locale.value === 'mn') {
          return `https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap`
        }
        else if (locale.value === 'bn') {
          return `https://fonts.googleapis.com/css2?family=Noto+Serif+Bengali:wght@100..900&display=swap`
        }
        // else if ((locale.value === 'cs' || locale.value === 'ro')) {
        else if (['cs', 'hu', 'ro', 'ru', 'vi'].includes(locale.value)) {
          return `https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap`
        }
        else if (locale.value === 'gu') {
          return `https://fonts.googleapis.com/css2?family=Noto+Sans+Gujarati:wght@100..900&display=swap`
        }
        else if (locale.value === 'ja') {
          return `https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100..900&display=swap`
        }
        else if (locale.value === 'or') {
          return `https://fonts.googleapis.com/css2?family=Noto+Sans+Oriya:wght@100..900&display=swap`
        }
        else if (locale.value === 'si') {
          return `https://fonts.googleapis.com/css2?family=Noto+Serif+Sinhala:wght@100..900&display=swap`;
        }
         else if (locale.value === 'ta') {
          return `https://fonts.googleapis.com/css2?family=Meera+Inimai&display=swap`
        }
         else if (locale.value === 'te') {
          return `https://fonts.googleapis.com/css2?family=Noto+Sans+Telugu:wght@100..900&display=swap`
        }
        return ''
      }),
    },
  ],
})

const route = useRoute()
const router = useRouter()

const { isShowLoginPopup, isLoggedIn } = useAuth()

const { isShowProfilePopup, hideProfilePopup, showProfilePopup, changeViewType } = useProfile()
const { markCoachReady } = useCoachMark()

watch(
  () => route.path,
  () => {
    hideProfilePopup()
  },
)

// 최초 가입 직후, 프로필 메인뷰를 자동으로 먼저 노출
// (콜백/로그인이 ?welcome=1 을 붙여 보냄. 백엔드 isNewUser === true 일 때만 붙으므로 가입 1회에만 동작)
onMounted(() => {
  if (route.query.welcome === '1' && isLoggedIn.value) {
    // 소비 후 URL에서 즉시 제거 (재진입·URL 공유 시 재실행 방지)
    const query = { ...route.query }
    delete query.welcome
    router.replace({ query })

    changeViewType('main')
    showProfilePopup(0, 0)
  }

  // 팝업 노출 판단이 끝난 뒤에 헤더 말풍선(1번) 노출을 허용
  markCoachReady()
})
</script>
